<template>
  <ExternalList
      endpoint="/api/v2/publication-based-ad-locations"
      :endpoint-filters="{publication_based_channel_id: publicationBasedChannel.id}"
      :headlines=" [{width: 20, text: 'Name'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/publication-based-ad-locations/priorities"
      :get-reorder-payload="data => ({publication_based_ad_locations: data})"
      @show="edit"
  >
    <template v-slot:default="{ row: publicationBasedAdLocation }">
      <td>
        {{ publicationBasedAdLocation.attributes.name }}
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :publicationBasedChannel="publicationBasedChannel" @created="load"/>

      <EditModal :publication-based-ad-location="editing" @updated="update"/>
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '../Modals/Create'
import EditModal from '../Modals/Edit'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {CreateModal, EditModal, ExternalList},

  props: {
    publicationBasedChannel: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  methods: {
    edit(publicationBasedAdLocation) {
      this.editing = publicationBasedAdLocation

      $('#edit-publication-based-ad-location-modal').modal('toggle')
    }
  }
}
</script>
